<div class="parentDiv">
<!-- <div class= "priceRegisterClass" *ngIf="this.isButtonVisible && !showHeader"> 
  <span id="pricingRegister">{{ 'Layout.RegistrationAlert' | translate }}</span>
  <button type="button" (click)="this.isButtonVisible = false" class="bootbox-close-button close">x</button>
</div> -->
<div class="container" *ngIf="!showHeader">
	<div class="row detailsDiv">
		<div class="col-sm-10"><img src="../assets/images/ue-logo.png" class="logoImage"/></div>
		<div class="col-sm-2"><a href="/" role="menuitem" tabindex="-1" class=" logout-doc navbar-brand padding-tb-0 activePagetab loggedout  ">{{ 'Common.Documentation' | translate }}</a></div>
	</div>
</div>
<div class="buttonBody" *ngIf="!showHeader">
		<div class="row buttonDiv col-sm-12">
			<div class="col-sm-6"></div>
			<div class="col-sm-6">
				<span>
					<a (click)="login()">{{ 'Common.Login' | translate }}</a>
				</span>
				<span>
					<button type="button" class="register-btn" data-toggle="modal" data-target="#myModal">{{ 'Common.Register' | translate }}</button>
				</span>
			</div>
		</div>
</div>
<app-login  [pwdBlock]="pwdBlock" [closeButton]="closeButton" (emitPass)="closeEvent($event)"></app-login> 
<app-header *ngIf="showHeader" [showHeader]="showHeader" (emitPass)="logout($event)"></app-header>
<div>
	<iframe src="//docs.unificationengine.com//#apps" class="home-iframe"></iframe>
</div>
</div>

<!-- Modal -->
<div id="myModal" class="modal fade" role="dialog">
  <div class="modal-dialog">

    <!-- Modal content-->
    <div class="modal-content modalContentStyle">
      <div class="modal-header">
	  <div style="position:relative;left:434px;bottom:13px">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
	  </div>
	  <div style="position:absolute">
        <p>{{ 'Layout.ContactMsg' | translate }}.</p>
	  </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal">{{ 'Common.Ok' | translate }}</button>
      </div>
    </div>

  </div>
</div>



<div class="container">
  <!-- Button to Open the Modal -->
 <!--  <button type="button" class="btn btn-primary" (click) = "show()">
    Open modal
  </button> -->

  <!-- The Modal -->
  <div class="modal" id="myModal" [style.display]="showModal ? 'block' : 'none'">
    <div class="modal-dialog">
      <div class="modal-content">    
        <!-- Modal Header -->
        <div class="modal-header reset-block">
          <div><h4 class="modal-title">{{ 'Layout.ResetPassword' | translate }}</h4></div>
		    <!-- <div><p>You can now enter the new password you want to use and activate it below.</p></div> -->
			<div><button type="button" class="close closeButton-resetBlock" data-dismiss="modal" (click) = "hide()">&times;</button></div>
        </div>
        
        <!-- Modal body -->
        <div class="modal-body">
          <input type="password" class="form-control inputFields" name="newPassword"  [(ngModel)]="newPassword" placeholder="{{ 'Layout.NewPassword' | translate }}" required>
          <input type="password" class="form-control inputFields" name="confirmPassword"  [(ngModel)]="confirmPassword" placeholder="{{ 'Layout.ConfirmPassword' | translate }}" required>
        </div>
        
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="reset-btn-login" (click)="login()">{{ 'Common.Login' | translate }}</button>{{ 'Common.OR' | translate }}
		  <button type="button" class="btn btn-info" (click)="resetingPassword()">{{ 'Layout.ActivatePassword' | translate }}</button>
        </div>
        
      </div>
    </div>
  </div>
</div>
